import * as React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { getRequest } from '../../../../../../Helper/ApiClient';

export default function MediaCenterFilter({
  filter,
  setFilter,
}: {
  filter: string[];
  setFilter: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  const mediaCategoriesRequest = getRequest(
    '/api/virtual-trade-show/media-categories'
  );

  // Initialize filter with all categories when data loads (allowlist approach)
  React.useEffect(() => {
    if (mediaCategoriesRequest.isSuccess && mediaCategoriesRequest.data && filter.length === 0) {
      setFilter(mediaCategoriesRequest.data.map((cat: any) => cat.name));
    }
  }, [mediaCategoriesRequest.isSuccess, mediaCategoriesRequest.data]);

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.checked) {
      let _filter = [...filter];
      _filter.push(event.currentTarget.value);
      setFilter(_filter);
    } else {
      let _filter = [...filter];
      let index = _filter.indexOf(event.currentTarget.value);
      _filter.splice(index, 1);
      setFilter(_filter);
    }
  };

  return (
    <>
      <p className="h2 fs-6">Filter media categories</p>
      {mediaCategoriesRequest.isSuccess &&
        mediaCategoriesRequest.data &&
        mediaCategoriesRequest.data.map((mediaCategory: any) => {
          return (
            <Form.Check
              checked={filter.includes(mediaCategory.name)}
              key={mediaCategory.name}
              label={mediaCategory.name}
              value={mediaCategory.name}
              onChange={handleFilterChange}
            />
          );
        })}
    </>
  );
}
